import { useTranslation } from "react-i18next";
import ItemToPayComponent, {
  ItemToPayComponentProps,
} from "../ItemToPayComponent/ItemToPayComponent";
import TransparentTile from "../TransparentTile/TransparentTile";
import styles from "./GuestTile.module.scss";

interface GuestTileProps {
  itemsToPay: ItemToPayComponentProps[];
  guestNumber: number;
  onItemCheckedChange?: (itemIndex: number, checked: boolean) => void;
}

function GuestTile(props: GuestTileProps) {
  const { itemsToPay, guestNumber, onItemCheckedChange } = props;
  const { t } = useTranslation();
  return (
    <TransparentTile>
      <>
        <div className={styles.guestTileHeader}>
          <i className={`las la-user-circle icon-xl ${styles.guestIcon}`} />
          <p className={`body-medium ${styles.guestName}`}>
            {t("gradientDrawer.payForYourItems.guest")} - {guestNumber}
          </p>
        </div>
        {itemsToPay.map((item, index) => (
          <ItemToPayComponent
            key={index}
            description={item.description}
            basePrice={item.basePrice}
            price={item.price}
            toppings={item.toppings}
            onCheckedChange={(checked) => onItemCheckedChange?.(index, checked)}
          />
        ))}
      </>
    </TransparentTile>
  );
}

export default GuestTile;
